import { useMemo } from 'react';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useLocationTimezone } from '../../../hooks';
import { useScheduleAppointmentInfoPanelShallowStore } from '../../../stores/schedule-appointment-info-panel.store';
import { prepareAppointmentInfo } from '../../schedule-calendar-components/helpers';
import { ApptPanelContextProvider, ApptPanelContextType } from './appt-panel-context';
import { PanelDetails } from './panel-details';
import { PanelHeader } from './panel-header';

export const AppointmentDetailsPanel = () => {
  const { selectedAppointment } = useScheduleAppointmentInfoPanelShallowStore('selectedAppointment');
  const { getLocationTimezoneAbbr } = useLocationTimezone();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { isV3OperatorySupported } = SchedulerV3.Helpers.useCheckV3OperatorySupport();
  const { isIntegratedOffice } = DataSourcesQueries.useGetAccessibleIntegrations();

  const contextValue = useMemo<ApptPanelContextType>(() => {
    const appointmentInfoToPrepare = selectedAppointment ? [selectedAppointment] : [];
    const apptDetails = prepareAppointmentInfo(
      appointmentInfoToPrepare ?? [],
      selectedAppointment?.id ?? '',
      getLocationTimezoneAbbr
    );

    return {
      apptDetails,
      isV3Enabled: isScheduleV3FlagEnabled,
      isIntegratedOffice: isIntegratedOffice,
      shouldShowOperatory: isIntegratedOffice || (isScheduleV3FlagEnabled && isV3OperatorySupported),
      locationId: selectedAppointment?.locationId || '',
    };
  }, [
    selectedAppointment,
    getLocationTimezoneAbbr,
    isScheduleV3FlagEnabled,
    isIntegratedOffice,
    isV3OperatorySupported,
  ]);

  return (
    <ApptPanelContextProvider value={contextValue}>
      <section css={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <PanelHeader />
        <PanelDetails />
      </section>
    </ApptPanelContextProvider>
  );
};
